import React from "react";
import { FiWifiOff, FiAlertTriangle, FiRefreshCw } from "react-icons/fi";
import { isNetworkError } from "../../utils/network";
import "./index.css";

/**
 * Shown instead of a table when its data couldn't be loaded.
 *   <LoadError error={err} message={msg} onRetry={reload} />
 * `error` (the original error) picks the icon/title: a Wi-Fi icon and
 * "No internet connection" for network problems, a warning otherwise.
 */
const LoadError = ({ error, message, onRetry, compact = false }) => {
  const network = isNetworkError(error) || /internet|offline|reach the server/i.test(message || "");
  const Icon = network ? FiWifiOff : FiAlertTriangle;
  return (
    <div className={`load-error ${compact ? "load-error--compact" : ""}`} role="alert">
      <div className={`load-error__icon ${network ? "is-network" : ""}`}>
        <Icon aria-hidden="true" />
      </div>
      <div className="load-error__text">
        <p className="load-error__title">{network ? "No internet connection" : "Couldn't load this"}</p>
        <p className="load-error__msg">{message}</p>
      </div>
      {onRetry && (
        <button type="button" className="load-error__retry" onClick={onRetry}>
          <FiRefreshCw aria-hidden="true" /> Try again
        </button>
      )}
    </div>
  );
};

export default LoadError;
